<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <!-- If using vue-router -->
      <!-- <router-view></router-view> -->
      <v-card>
        <v-tabs v-model="tab">
          <v-tab>Pertanyaan</v-tab>
          <v-tab>Hasil Kuesioner</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <v-card-title>
                Loyalitas
                <v-spacer></v-spacer>

                <v-btn color="purple" dark class="mb-2" @click="doAdd">
                  Tambah
                </v-btn>

                <v-dialog v-model="dialog" persistent max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Rumah Sakit</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        class="pl-4 pr-4"
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="currentData.pertanyaan"
                                label="Pertanyaan"
                                required
                                :rules="currentData.pertanyaanRules"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-combobox
                                v-model="currentData.selectedCategory"
                                label="Kategori"
                                dense
                                outlined
                                :items="items_categories"
                                item-text="nama"
                                :rules="currentData.categoryRules"
                              ></v-combobox>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="currentData.urutan"
                                label="Urutan"
                                required
                                :rules="currentData.urutanRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialog = false">
                        Close
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="doSave">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Apa anda akan menghapus data ini?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Tidak</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItemConfirm"
                        >Ya</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-title>

              <v-row class="mx-4 my-4">
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Cari Pertanyaan"
                    single-line
                    outlined
                    dense
                    hide-details
                    @keyup.enter="getDataFromApi"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="list_data"
                :options.sync="options"
                :server-items-length="totalData"
                :loading="loading"
                class="elevation-1"
                :single-select="true"
                show-select
              >
                <template #[`item.actions`]="{ item }">
                  <div class="d-flex">
                    <v-icon medium class="mr-3" @click="editItem(item)">
                      mdi-pencil
                    </v-icon>
                    <v-icon medium @click="deleteItem(item)">
                      mdi-delete
                    </v-icon>
                  </div>
                </template>
              </v-data-table>
            </v-card>

            <v-card class="mt-4">
              <PsikologisOpsiJawaban
                v-if="selected != undefined && selected.length > 0"
                :id="selected[0].id"
                ref="mychild"
                :key="childKey"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <PsikologisHasil />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import PsikologisDiscService from "../../services/PsikologisDiscService";
import PsikologisKategorisService from "../../services/PsikologisKategorisService";
import CommonService from "../../services/CommonService";

import PsikologisOpsiJawaban from "./PsikologisOpsiJawaban.vue";
import PsikologisHasil from "./PsikologisHasil.vue";

export default {
  components: {
    PsikologisOpsiJawaban,
    PsikologisHasil,
  },
  data: () => ({
    tab: null,
    valid: true,
    childKey: 0,
    selected: [],
    breadcrumbs: [
      {
        text: "Data Kuesioner",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Pertanyaan", value: "pertanyaan", sortable: false },
      { text: "Kategori", value: "nama_kategori", sortable: false },
      { text: "Urutan", value: "urutan", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 5,
    },

    items_categories: [],

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentData: {
      id: null,
      pertanyaan: "",
      urutan: "",
      alat_test_id: 2,
      selectedCategory: null,
      pertanyaanRules: [(v) => !!v || "Pertanyaan harus diisi"],
      urutanRules: [(v) => !!v || "Urutan harus diisi"],
      categoryRules: [(v) => !!v || "Kategori harus diisi"],
    },
  }),
  watch: {
    selected: {
      handler() {
        if (this.selected != undefined && this.selected[0]) {
          this.childKey++;
        }
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
    this.getListKategori();
  },
  methods: {
    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      PsikologisDiscService.getList(page, itemsPerPage, this.search, 2)
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    getListKategori() {
      PsikologisKategorisService.getListAll(2)
        .then((res) => {
          this.items_categories = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.currentData.id = null;
      this.currentData.pertanyaan = "";
      this.currentData.urutan = "";
      this.currentData.selectedCategory = null;
    },

    doSave: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      if (this.currentData.id != null) {
        PsikologisDiscService.update(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Update pertanyaan berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Update pertanyaan gagal. Coba lagi");
          });
      } else {
        PsikologisDiscService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Tambah pertanyaan berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Tambah pertanyaan gagal. Coba lagi");
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.currentData.pertanyaan = this.editedItem.pertanyaan;
      this.currentData.urutan = this.editedItem.urutan;
      this.currentData.id = this.editedItem.id;

      this.currentData.selectedCategory = null;

      if (this.editedItem.psikologis_category_id) {
        this.items_categories.forEach((entry) => {
          if (entry.id == this.editedItem.psikologis_category_id) {
            this.currentData.selectedCategory = entry;
          }
        });
      }

      this.currentData.fotoKey++;
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      PsikologisDiscService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus pertanyaan berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);

          CommonService.showErrorToast("Hapus pertanyaan gagal. Coba lagi");
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
